<script lang="ts">
import Vue from 'vue'
import Card from "@/components/ui/Card";
import Checkbox from "@/components/ui/Checkbox";
import TariffSetting from "@/views/insuranceProducts/components/TariffSetting.vue";
import tariffMixin from "@/views/insuranceProducts/mixins/tariffMixin"

export default Vue.extend({
    name: "TariffHomeItem",
    components: {TariffSetting, Checkbox, Card},
    props: {
        tariff: {
            type: Object,
        },
        companyName: {
            default() {
                return ''
            }
        }
    },
    mixins: [tariffMixin],
})
</script>

<template>
    <div>
        <Card>
            <div class="tariff-item d-flex justify-content-between flex-row align-items-center">
                <div class="column">
                    <div class="head">Тип продукту</div>
                    <div class="d-flex">
                        <div class="mr-2" v-if="$route.params.id">
                            <Checkbox v-model="tariff.isActive" @change="updateTariff(tariff)"></Checkbox>
                        </div>
                        <div>
                            Страхування житла
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="head">Комісія/Знижка, %</div>
                    <div v-if="$route.params.id">
                        <TariffSetting v-model="tariff" :hide-discount="true">
                            Налаштування тарифів {{ companyName }} для точки продажу id: {{ tariff.userId }}
                        </TariffSetting>
                    </div>
                    <div v-else-if="isMainPartner">{{ tariff.commission - tariff.gap }}</div>
                    <div v-else>{{ tariff.commission }}</div>
                </div>
                <div class="column">
                    <div class="head">Обʼєкт страхування</div>
                    <div>{{ tariff.parameters.homeTypes ? tariff.parameters.homeTypes.map(item => item === 'flat' ? 'Страхування квартири' : 'Страхування будинку').join(', ') : '' }}</div>
                </div>
                <div class="column">
                    <div class="head">Страхова сума</div>
                    <div>{{ tariff.parameters.coveragesHome ? tariff.parameters.coveragesHome.join(', ') : '' }}</div>
                </div>
                <div class="column">
                    <div class="head">Період</div>
                    <div>{{ tariff.parameters.periodsHome ? tariff.parameters.periodsHome.join(', ') : '' }}</div>
                </div>
            </div>
        </Card>
    </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/app/components/_tariff-item";

</style>
